import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { AuthService } from '@app/core/services/auth.service';
import { HTTP_STATUS_CODE } from '@app/core/constants/system.constants';

@Component({
  selector: 'app-verify-2fa',
  templateUrl: './verify-2fa.component.html',
  styleUrls: ['./verify-2fa.component.scss']
})
export class Verify2faComponent implements OnInit {
  bgLoginPath = environment.bgLogin;
  logoPath = environment.logo;
  form!: FormGroup;
  recoveryForm!: FormGroup;
  isSubmitted = false;
  isLoading = false;
  useRecovery = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Không có ngữ cảnh đăng nhập (vào thẳng URL) → quay lại trang login
    if (!sessionStorage.getItem('ssoReqParams')) {
      this.router.navigate(['/login']).then();
      return;
    }
    this.form = this.fb.group({ code: [null, Validators.required] });
    this.recoveryForm = this.fb.group({ recoveryCode: [null, Validators.required] });
  }

  get f() {
    return this.form.controls;
  }

  get rf() {
    return this.recoveryForm.controls;
  }

  toggleRecovery(): void {
    this.useRecovery = !this.useRecovery;
    this.isSubmitted = false;
  }

  submit(): void {
    this.isSubmitted = true;
    if (this.form.invalid) return;
    this.isLoading = true;
    this.authService.verifyMfa(this.form.value.code).subscribe({
      next: (res) => this.handleResult(res),
      error: (err) => this.handleError(err)
    });
  }

  submitRecovery(): void {
    this.isSubmitted = true;
    if (this.recoveryForm.invalid) return;
    this.isLoading = true;
    this.authService.mfaRecovery(this.recoveryForm.value.recoveryCode).subscribe({
      next: (res) => this.handleResult(res),
      error: (err) => this.handleError(err)
    });
  }

  backToLogin(): void {
    this.router.navigate(['/login']).then();
  }

  private handleResult(res: any): void {
    if (res?.code === HTTP_STATUS_CODE.SUCCESS) {
      this.redirectToAuthorize();
    } else {
      this.isLoading = false;
      this.toastr.error(res?.message);
    }
  }

  private handleError(err: any): void {
    this.isLoading = false;
    this.toastr.error(err?.error?.message || this.translate.instant('common.error.system'));
  }

  private redirectToAuthorize(): void {
    const state = sessionStorage.getItem('ssoState') || '';
    const reqParams = sessionStorage.getItem('ssoReqParams') || '';
    window.location.href = `${environment.backend.sso}/oauth2/authorize?state=${state}&${reqParams}`;
  }
}
